// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-rcj[data-v-0494d21c] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 600px;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/ChangeRcj.vue","webpack://./ChangeRcj.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;ACAF","sourcesContent":["\n.change-rcj {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 600px;\n  gap: 10px;\n}\n",".change-rcj {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  height: 600px;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
